import {
  Avatar,
  Container,
  IconButton,
  List,
  ListDivider,
  ListItem,
  ListItemButton,
  ListItemContent,
  ListItemDecorator,
} from "@mui/joy";
import * as React from "react";
import HeaderBackButton from "../components/HeaderBackButton";
import { KeyboardArrowRight } from "@mui/icons-material";

export default function Buy() {
  return (
    <>
      <HeaderBackButton title={"Buy Crypto"} />
      <Container maxWidth="sm">
        <List
          size="lg"
          variant="outlined"
          sx={{ minWidth: 240, borderRadius: "sm" }}
        >
          {[
            {
              title: "Transak",
              link: "https://global.transak.com/",
              image: "./images/transak.jpeg",
            },
            {
              title: "Alchemy",
              link: "https://ramp.alchemypay.org",
              image: "./images/alchemy.jpg",
            },
          ].map((buy, index) => (
            <>
              <ListItem key={index + buy.title}>
                <ListItemDecorator>
                  <Avatar size="sm" variant="outlined" src={buy.image} />
                </ListItemDecorator>
                <ListItemContent>{buy.title}</ListItemContent>
                <IconButton
                  variant="plain"
                  onClick={() => window.open(buy.link, "_blank")}
                >
                  <KeyboardArrowRight />
                </IconButton>
              </ListItem>

              <ListDivider inset="context" />
            </>
          ))}

          <ListItem>
            <ListItemDecorator>
              <Avatar size="sm" src="/images/moonpay.png" />
            </ListItemDecorator>
            <ListItemContent>{"Moonpay"}</ListItemContent>
            <IconButton
              onClick={() =>
                window.open("https://www.moonpay.com/en-gb/buy", "_blank")
              }
              variant="plain"
            >
              <KeyboardArrowRight />
            </IconButton>
          </ListItem>
        </List>
      </Container>
    </>
  );
}
